import { useTranslation } from 'react-i18next';
import { useLocation } from 'wouter';
import {
  ReactComponent as BackwardBreadCrumpIcon,
} from '../../assets/icons/Button-Control icons/Breaccrumb back button.svg';
import { useEntryOrSoloSystemRoute } from '../../shared/appShellComponents/AppRouteSwitch';
import { useSiteInfo } from '../../shared/appUIFramework/appBackend/useSiteInfo';
import AppContentToolbar from '../../shared/appUIFramework/components/AppContentToolbar';
import AppShowLoading from '../../shared/appUIFramework/components/AppShowLoading';
import EntryUserForm from './components/EntryUserForm';

export default function SystemEntryUsersNew() {
  const { t } = useTranslation();
  const [, setLocation] = useLocation();
  const [, params] = useEntryOrSoloSystemRoute('/systems/:siteId/entry-users/:entryUserId');
  const siteId = params?.siteId;
  const { siteInfo } = useSiteInfo(siteId);
  const goToSite = () => {
    if (siteId) {
      setLocation(`/systems/${siteId}/entry-users`);
    }
  };
  return (
    <>
      <AppContentToolbar>
        <AppShowLoading inline showLoading={siteInfo == null}>
          {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events */}
          <span className="app-toolbar-breadcrumb-separator app-hover-pointer" onClick={goToSite}><BackwardBreadCrumpIcon /></span>
          <span className="app-toolbar-breadcrumb">{t('Solo_PaxtonEntry')}</span>
          <span className="app-toolbar-breadcrumb-separator app-rotate-svg-180"><BackwardBreadCrumpIcon /></span>
          {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events */}
          <span className="app-toolbar-breadcrumb app-hover-pointer" onClick={goToSite}>{ siteInfo?.siteName }</span>
          <span className="app-toolbar-breadcrumb-separator app-rotate-svg-180"><BackwardBreadCrumpIcon /></span>
          <span className="app-toolbar-breadcrumb">{ t('Sites_AddNewMobile') }</span>
        </AppShowLoading>
      </AppContentToolbar>
      <EntryUserForm disabled={false} />
    </>
  );
}
